<template lang="pug">
  div
    h1.title.is-3.has-text-info(style='margin-bottom: 5px;') Usuarios
    .buttons(style='margin-bottom: 10px;' )
      button.button.is-info.is-light(@click="reloadData")
        span.icon.is-small(:class="{ 'is-loading': storing }")
          i.fas.fa-redo-alt
      button.button.is-primary.is-light(@click="addData")
        span.icon.is-small
          i.fas.fa-plus
    .columns(style="margin-bottom: 0; margin-top: 20px;")
      .column
        .control.has-icons-left(:class="{'has-icons-right': search !== ''}")
          input.input.is-small.is-rounded(type="text" placeholder="Busqueda" v-model="search")
          span.icon.is-small.is-left.has-text-info
            i.fas.fa-search
          span.icon.is-small.is-right.has-text-danger(
            v-if="search !== ''"
            @click="search = ''"
            style="cursor: pointer; pointer-events: initial;")
            i.fas.fa-times
      //- .column
        .field.is-horizontal
          .field-label.is-small
            label.label Elementos:
          .field-body
            .field
              .control
                .select.is-small.is-rounded
                  select(v-model="perPage")
                    option(v-for="ppItem in perPageList") {{ ppItem }}
    div(v-if="registrosSearched.length" style="overflow: auto;")
      table.table.is-fullwidth
        thead
          tr
            th ID
            th Correo
            th Permisos
            //- th Propiedades
            th Super
            th Acciones
        tbody
          tr(
            v-for="registro in registrosSearched"
            :key="registro.id"
            :style="{backgroundColor: registro.deleted ? '#dadada' : 'white'}"
          )
            td {{ registro.id }}
            td {{ registro.email }}
            td
              button.button.is-info.is-rounded.is-small.is-ligth.is-outlined(@click="openPermissions(registro)")
                span.icon.is-small
                  i.fab.fa-js
            //- td 
            //-   button.button.is-info.is-rounded.is-small.is-ligth.is-outlined
            //-     span.icon.is-small
            //-       i.fab.fa-js
            td
              span.icon.is-small.has-text-success(v-if="registro.superuser")
                i.far.fa-check-square
              span.icon.is-small.has-text-danger(v-else)
                i.far.fa-times-circle
            td
              p.buttons
                //- button.button.is-info.is-rounded.is-small.is-ligth(v-if="!registro.deleted")
                //-   span.icon.is-small
                //-     i.far.fa-edit
                button.button.is-danger.is-rounded.is-small.is-ligth(
                  v-if="!registro.deleted"
                  @click="setDelete(registro.id)"
                )
                  span.icon.is-small
                    i.fas.fa-eraser
                button.button.is-warning.is-rounded.is-small.is-ligth(
                  v-if="registro.deleted"
                  @click="setUndelete(registro.id)"
                )
                  span.icon.is-small
                    i.fas.fa-trash-restore

    .title.is-4(v-else) No hay registros.

    //- nav.pagination.is-centered.is-rounded.is-small(role="navigation" aria-label="pagination")
      a.pagination-previous Anterior
      a.pagination-next Siguiente
      //- ul.pagination-list
        li
          a.pagination-link(aria-label="Goto page 1") 1
        li
          span.pagination-ellipsis &hellip;
        li
          a.pagination-link(aria-label="Goto page 45") 45
        li
          a.pagination-link.is-current(aria-label="Page 46" aria-current="page") 46
        li
          a.pagination-link(aria-label="Goto page 47") 47
        li
          span.pagination-ellipsis &hellip;
        li
          a.pagination-link(aria-label="Goto page 86") 86

    Modal(v-model="confirmModal")
      .modal-card
        article.message.is-danger
          .message-header
            p.is-3 Advertencia
          .message-body.has-text-centered ¿ Está seguro de eliminar el registro ?
          .buttons(style="margin-bottom: 10px; display: inline-block; position: relative; left: 50%; transform: translateX(-50%);")
            button.button.is-danger(@click="continueDelete(confirmModal)")
              span Confirmar
            button.button.is-info(@click="confirmModal = false")
              span Cancelar
    Modal(v-model="permissionModal")
      .modal-card
        article.message
          .message-header
            p.is-3 Permisos
          .message-body
            vue-tree-list(
              :model="permissionData"
              default-tree-node-name="Nuevo nodo"
              default-leaf-node-name="Nueva hoja"
              :default-expanded="false"
            )
              span.icon(slot="addTreeNodeIcon") 📂
              span.icon(slot="addLeafNodeIcon") ＋
              span.icon(slot="editNodeIcon") 📃
              span.icon(slot="delNodeIcon") ✂️
              span.icon(slot="leafNodeIcon") 🍃
              span.icon(slot="treeNodeIcon") 🌲

          .buttons(style="margin-bottom: 10px; display: inline-block; position: relative; left: 50%; transform: translateX(-50%);")
            button.button.is-success(@click="savePermission")
              span Guardar
            button.button.is-info(@click="permissionModal = false")
              span Cancelar
    Modal(v-model="openModal")
      .modal-card
        header.modal-card-head
          p.modal-card-title {{ selectedId ? "Edición" : "Creación"}} de Usuario
        section.modal-card-body
          .field
            label.label(for="elmName") Nombre *
            .control
              input.input(id="elmName" type="text" placeholder="Ingresa el nombre" v-model="objetivo.name")
          .field
            label.label(for="elmCorreo") Correo *
            .control
              input.input(type="email" id="elmCorreo" placeholder="Correo" v-model="objetivo.email")
        footer.modal-card-foot
          button.button.is-success(@click="saveData" :class="{ 'is-loading': storing }") Guardar
</template>

<script>
import Modal from "@/components/Modal";
import { VueTreeList, Tree } from "vue-tree-list";
import _get from "lodash/get";

export default {
  name: "config-usuario-component",

  components: {
    Modal,
    VueTreeList
  },

  data: () => ({
    page: 1,
    perPage: 10,
    perPageList: [10, 25, 50],
    search: "",
    registrosSearched: [],
    timersearch: null,
    openModal: false,
    confirmModal: false,
    permissionModal: false,
    permissionData: new Tree([
      {
        id: 0,
        pid: 0,
        name: "Raiz",
        children: []
      }
    ]),
    selectedId: null,
    objetivo: {
      name: "",
      email: "",
      permisos: {},
      propiedades: {},
      superuser: false
    }
  }),

  watch: {
    search() {
      this.checksearch();
    },
    openModal(val, oldVal) {
      if (!val && val !== oldVal) {
        this.selectedId = null;
      }
    },
    registros() {
      this.searchList();
    },
    permissionModal(val, oldVal) {
      if (!val && val !== oldVal) {
        this.selectedId = null;
        this.permissionData = new Tree([
          {
            id: 0,
            pid: 0,
            name: "Raiz",
            children: []
          }
        ]);
      }
    }
  },

  created() {
    this.reloadData();
  },

  computed: {
    registros() {
      return this.$store.state.usuarios_list;
    },
    storing() {
      return this.$store.state.usuarios_load;
    }
  },

  methods: {
    async softDelete(id, deleted) {
      this.selectedId = id;
      this.objetivo = {
        deleted
      };
      await this.saveData();
    },
    checksearch() {
      if (this.search === "" || this.search.length > 2) {
        if (this.timersearch !== null) clearTimeout(this.timersearch);
        this.timersearch = setTimeout(() => this.searchList(), 300);
      }
    },
    searchList() {
      this.registrosSearched = this.registros.filter(reg => {
        if (this.search === "") return true;
        return (
          (typeof reg.email === "string" &&
            reg.email.indexOf(this.search) > -1) ||
          (typeof reg.name === "string" &&
            reg.name.indexOf(this.search) > -1) ||
          (typeof reg.id === "string" && reg.id.indexOf(this.search) > -1) ||
          Object.keys(reg.permisos || {}).reduce(
            (prev, curr) =>
              prev ||
              (typeof curr === "string" && curr.indexOf(this.search) > -1),
            false
          )
        );
      });
    },
    openPermissions(data) {
      this.selectedId = data.id;
      const tempPerm = JSON.parse(JSON.stringify(data.permisos));
      const recursiveFunction = (permissions, numberIdsAdder = 1) => {
        return Object.keys(permissions).map((name, idx) => {
          return {
            id: idx + numberIdsAdder,
            pid: idx + numberIdsAdder,
            name,
            children:
              permissions[name] && name !== "id"
                ? recursiveFunction(permissions[name], numberIdsAdder + 50)
                : []
          };
        });
      };
      const arrayOrder = recursiveFunction(tempPerm);
      this.permissionData = new Tree([
        {
          id: 0,
          pid: 0,
          name: "Raiz",
          children: arrayOrder
        }
      ]);
      this.permissionModal = true;
    },
    async savePermission() {
      const elements = _get(this.permissionData, "children[0].children") || [];
      const circularObject = (children, parentObject = {}) => {
        for (const elm of children)
          parentObject[elm.name] = circularObject(_get(elm, "children") || []);
        return parentObject;
      };
      this.objetivo = {
        permisos: circularObject(elements)
      };
      await this.saveData();
      this.permissionModal = false;
    },
    reloadData() {
      return this.$store.dispatch("listUsuario", {
        page: this.page,
        perPage: this.perPage,
        search: this.search
      });
    },
    addData() {
      this.openModal = true;
    },
    setDelete(id) {
      this.confirmModal = id;
    },
    setUndelete(id) {
      return this.softDelete(id, false);
    },
    continueDelete(id) {
      this.confirmModal = false;
      return this.softDelete(id, true);
    },
    setedition(element) {
      this.selectedId = element.id;
      this.objetivo.nombre = element.nombre;
      this.objetivo.descripcion = element.descripcion;
      this.openModal = true;
    },
    async saveData() {
      let action;
      if (!this.selectedId) {
        action = this.$store.dispatch("storeUsuario", {
          data: this.objetivo
        });
      } else {
        action = this.$store.dispatch("updateUsuario", {
          id: this.selectedId,
          data: this.objetivo
        });
      }
      try {
        await action;
        this.objetivo.nombre = "";
        this.objetivo.descripcion = "";
        this.$toastr(
          "success",
          this.selectedId
            ? "El registro se actualizó correctamente."
            : "El registro se creó correctamente."
        );
      } catch (error) {
        console.error(error);
        this.$toastr(
          "error",
          this.selectedId
            ? "El registro no se pudo actualizar."
            : "El registro no se pudo crear."
        );
      }
      this.selectedId = null;
      this.openModal = false;
    }
  }
};
</script>
